import { LocaleStrings } from '@/types/paramModels';
import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators';

enum locales {
    "da" = "da-DA"
}

@Module({ namespaced: true, })
class ApplicationModule extends VuexModule {
    public pageUrls?: Array<{[key: string]: string}>;
    public pageTexts?: Array<{[key: string]: string}>;
    public accommodationIndex = 0;
    public pensionIndex = 0;
    public personalDataIndex = 0;
    public currentViewName?: string;
    public localeStrings?: LocaleStrings;


    @Mutation
    private setLocaleStrings(locale: string) {     
        const newLocale: LocaleStrings = {
            name: locale ?? "",
            longName: locales[locale] ?? ""
        }
        this.localeStrings = newLocale;
    }

    @Action
    public updateLocaleStrings(locale: string) {
        this.context.commit('setLocaleStrings', locale);
    }

    get getLocaleStrings(): LocaleStrings {
        return this.localeStrings as LocaleStrings;
    }

    @Mutation
    private setIncrementPersonalDataIndex() {
        this.personalDataIndex++;
    }

    @Action
    public incrementPersonalDataIndex() {
        this.context.commit('setIncrementPersonalDataIndex');
    }

    @Mutation
    private setDecrementPersonalDataIndex() {
        this.personalDataIndex--;
    }

    @Action
    public decrementPersonalDataIndex() {
        this.context.commit('setDecrementPersonalDataIndex');
    }

    @Mutation
    private setResetPersonalDataIndex() {
        this.personalDataIndex = 0;
    }

    @Action
    public resetPersonalDataIndex() {
        this.context.commit('setResetPersonalDataIndex');
    }

    get getPersonalDataIndex(): number {
        return this.personalDataIndex;
    }

    @Mutation
    private setCurrentViewName(currentViewName: string) {
        this.currentViewName = currentViewName;
    }

    @Action
    public updateCurrentViewName(currentViewName: string) {
        this.context.commit('setCurrentViewName', currentViewName);
    }

    get getCurrentViewName(): string | undefined {
        return this.currentViewName;
    }

    @Mutation
    private setIncrementAccommodationIndex() {
        this.accommodationIndex++;
    }

    @Action
    public incrementAccommodationIndex() {
        this.context.commit('setIncrementAccommodationIndex');
    }

    @Mutation
    private setDecrementAccommodationIndex() {
        this.accommodationIndex--;
    }

    @Action
    public decrementAccommodationIndex() {
        this.context.commit('setDecrementAccommodationIndex');
    }

    @Mutation
    private setResetAccommodationIndex() {
        this.accommodationIndex = 0;
    }

    @Action
    public resetAccommodationIndex() {
        this.context.commit('setResetAccommodationIndex');
    }

    get getAccommodationIndex(): number {
        return this.accommodationIndex;
    }

    @Mutation
    private setIncrementPensionIndex() {
        this.pensionIndex++;
    }

    @Action
    public incrementPensionIndex() {
        this.context.commit('setIncrementPensionIndex');
    }

    @Mutation
    private setDecrementPensionIndex() {
        this.pensionIndex--;
    }

    @Action
    public decrementPensionIndex() {
        this.context.commit('setDecrementPensionIndex');
    }

    @Mutation
    private setResetPensionIndex() {
        this.pensionIndex = 0;
    }

    @Action
    public resetPensionIndex() {
        this.context.commit('setResetPensionIndex');
    }

    get getPensionIndex(): number {
        return this.pensionIndex;
    }

    @Mutation
    public setPageUrls(pageUrls: Array<{[key: string]: string}>): void {
        this.pageUrls = pageUrls;
    }

    @Action
    public updatePageUrls(pageUrls: Array<{[key: string]: string}>): void {
        this.context.commit('setPageUrls', pageUrls);
    }

    get getPageUrls(): Array<{[key: string]: string}> {
        return this.pageUrls as Array<{[key: string]: string}>;
    }

    @Mutation
    public setPageTexts(pageTexts: Array<{[key: string]: string}>): void {
        this.pageTexts = pageTexts;
    }

    @Action
    public updatePageTexts(pageTexts: Array<{[key: string]: string}>): void {
        this.context.commit('setPageTexts', pageTexts);
    }

    get getPageTexts(): Array<{[key: string]: string}> {
        return this.pageTexts as Array<{[key: string]: string}>;
    }
}

export default ApplicationModule;